var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7368 2.10992C10.4485 1.56492 9.5518 1.56492 9.26346 2.10992L1.76346 16.2766C1.69595 16.4036 1.66248 16.5459 1.66631 16.6896C1.67015 16.8334 1.71115 16.9737 1.78534 17.0969C1.85953 17.2201 1.96436 17.322 2.08963 17.3926C2.21489 17.4632 2.35632 17.5002 2.50013 17.4999H17.5001C17.6438 17.5002 17.7852 17.4633 17.9104 17.3927C18.0355 17.3221 18.1403 17.2203 18.2144 17.0971C18.2885 16.974 18.3295 16.8338 18.3332 16.6901C18.337 16.5465 18.3035 16.4043 18.236 16.2774L10.7368 2.10992ZM10.8335 14.9999H9.1668V13.3333H10.8335V14.9999ZM9.1668 11.6666V7.49992H10.8335L10.8343 11.6666H9.1668Z",
    fill: "#FF3434"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginError);
export default __webpack_public_path__ + "static/media/login_error.66c3e85ebba2c12d09535af1b2e2c9a6.svg";
export { ForwardRef as ReactComponent };